import { useLayoutEffect, type RefObject } from 'react'

import { syncTextareaAutosizeHeight } from '@/lib/utils/sync-textarea-autosize-height'

export function useAutosizeTextarea(
  ref: RefObject<HTMLTextAreaElement | null>,
  value: string,
  options: { maxHeightPx: number; disabled?: boolean },
): void {
  const { maxHeightPx, disabled = false } = options

  useLayoutEffect(() => {
    if (disabled) return
    const el = ref.current
    if (!el) return
    syncTextareaAutosizeHeight(el, maxHeightPx)
  }, [ref, value, maxHeightPx, disabled])
}
